/* ==================================================
=            Define Families and Sizes.             =
================================================== */
/* ----------  Font Families  ---------- */

const fonts = {
  CLA: 'classic',
  ORL: 'york',
  SCR: 'script',
  GOT: 'gothic',
  SOU: 'vintage',
  DEC: {
    left: 'deco_leftmedium',
    middle: 'deco_middlemedium',
    right: 'deco_rightmedium'
  },
  decoLeft: 'deco_leftmedium',
  decoMiddle: 'deco_middlemedium',
  decoRigth: 'deco_rightmedium'
};
/* ----------  Font Sizes  ---------- */
// Consider 55px = 1 inch aprox.
// Normal Monogram
const sizeMonogram = 27.5;
const sizeStandardMonogram = 40;
// BIG MONOGRAM.
const bigSizes = {
  scriptCenter: 58.10546875,
  scriptEdges: 34.1796875,
  gothicCenter: 71.77734375,
  gothicEdges: 41.015625,
  decoCenter: 109.375,
  decoEdges: 68.359375
};
// NORMAL MONOGRAM
const sizes = {
  classicCenter: 55,
  classicEdges: sizeMonogram,
  yorkCenter: 55,
  yorkEdges: sizeMonogram,
  scriptCenter: 55,
  scriptEdges: sizeMonogram,
  gothicCenter: 82.5,
  gothicEdges: sizeMonogram,
  decoCenter: 110,
  // the deco edges is not being used because of the font provided for center.
  decoEdges: sizeMonogram
};
const FACTOR = 3;
const fontid = {
  '100GOT0': { size: [41.0156249978638, 71.7773437462616, 41.0156249978638], order: [0, 2, 1] },
  '100GOT1': { size: [71.7773437462616], order: [0] },
  '100GOT2': { size: [71.7773437462616, 71.7773437462616], order: [0, 2] },
  '100GOT3': { size: [71.7773437462616, 71.7773437462616, 71.7773437462616], order: [0, 1, 2] },
  '100SCR0': { size: [34.1796874982198, 58.1054687469737, 34.1796874982198], order: [0, 2, 1] },
  '100SCR1': { size: [58.1054687469737], order: [0] },
  '100SCR2': { size: [58.1054687469737, 58.1054687469737], order: [0, 2] },
  '150SCR0': { size: [40, 82, 40], order: [0, 2, 1] },
  '150SCR3': { size: [65, 65, 65], order: [0, 1, 2] },
  '200SCR0': { size: [56, 90, 56], order: [0, 2, 1] },
  '200SCR2': { size: [90, 90], order: [0, 2] },
  '150GOT2': { size: [82.0312499957275, 82.0312499957275], order: [0, 2] },
  '150GOT3': { size: [82.0312499957275, 82.0312499957275, 82.0312499957275], order: [0, 1, 2] },
  '100DEC0': { size: [34.1796874982198, 54.6874999971517, 34.1796874982198], order: [0, 2, 1], minLength: 3 },
  '100DEC2': { size: [54.6874999971517, 54.6874999971517], order: [0, 2], minLength: 2 },
  '200DEC0': { size: [68.3593749964396, 109.374999994303, 68.3593749964396], order: [0, 2, 1], minLength: 3 }, // Big Monogram - Deco
  '200DEC2': { size: [109.374999994303, 109.374999994303], order: [0, 2], minLength: 2 }, // Big Monogram - Deco 2
  '200GOT1': { size: [109.374999994303], order: [0] },
  '300GOT1': { size: [136.718749992879], order: [0] },
  '200SCR1': { size: [109.374999994303], order: [0] },
  '300SCR1': { size: [136.718749992879], order: [0] },

  '050CLA0': { size: [17.0898437491099, 27.3437499985758, 17.0898437491099], order: [0, 2, 1] },
  '050CLA2': { size: [27.3437499985758, 27.3437499985758], order: [0, 2] },
  '050CLA3': { size: [27.3437499985758, 27.3437499985758, 27.3437499985758], order: [0, 1, 2] },
  '050DEC0': { size: [17.0898437491099, 27.3437499985758, 17.0898437491099], order: [0, 2, 1], minLength: 3 }, // Classic Monogram - Deco
  '050DEC2': { size: [27.3437499985758, 27.3437499985758], order: [0, 2], minLength: 2 }, // Classic Monogram - Deco 2
  '050ORL0': { size: [17.0898437491099, 30.7617187483978, 17.0898437491099], order: [0, 2, 1] },
  '050ORL2': { size: [30.7617187483978, 30.7617187483978], order: [0, 2] },
  '050ORL3': { size: [30.7617187483978, 30.7617187483978, 30.7617187483978], order: [0, 1, 2] },
  '150ORL0': { size: [51.0898437491099, 82.0312499957275, 51.0898437491099], order: [0, 2, 1] },
  '150ORL2': { size: [82.0312499957275, 82.0312499957275], order: [0, 2] },
  '150ORL3': { size: [82.0312499957275, 82.0312499957275, 82.0312499957275], order: [0, 1, 2] },
  '050SCR0': { size: [20.5078124989319, 34.1796874982198, 20.5078124989319], order: [0, 2, 1] },
  '050SCR2': { size: [34.1796874982198, 34.1796874982198], order: [0, 2] },
  '050SOU2': { size: [34.1796874982198, 34.1796874982198], order: [0, 2] },
  '050SOU3': { size: [34.1796874982198, 34.1796874982198, 34.1796874982198], order: [0, 1, 2] },

  '050GOT0': { size: [34.1796874982198, 34.1796874982198, 34.1796874982198], order: [0, 2, 1] },
  '050GOT2': { size: [34.1796874982198, 34.1796874982198], order: [0, 2] },
  '050GOT3': { size: [34.1796874982198, 34.1796874982198, 34.1796874982198], order: [0, 1, 2] },

  // New fonts for cup:
  'B050CLA0': { size: [FACTOR * 17.0898437491099, FACTOR * 27.3437499985758, FACTOR * 17.0898437491099], order: [0, 2, 1] },
  'B050CLA2': { size: [FACTOR * 27.3437499985758, FACTOR * 27.3437499985758], order: [0, 2] },
  'B050CLA3': { size: [FACTOR * 27.3437499985758, FACTOR * 27.3437499985758, FACTOR * 27.3437499985758], order: [0, 1, 2] },
  'B050DEC0': { size: [FACTOR * 17.0898437491099, FACTOR * 27.3437499985758, FACTOR * 17.0898437491099], order: [0, 2, 1], minLength: 3 },
  'B050DEC2': { size: [FACTOR * 27.3437499985758, FACTOR * 27.3437499985758], order: [0, 2], minLength: 2 },
  'B050GOT0': { size: [FACTOR * 34.1796874982198, FACTOR * 34.1796874982198, FACTOR * 34.1796874982198], order: [0, 2, 1] },
  'B050GOT2': { size: [FACTOR * 34.1796874982198, FACTOR * 34.1796874982198], order: [0, 2] },
  'B050GOT3': { size: [FACTOR * 34.1796874982198, FACTOR * 34.1796874982198, FACTOR * 34.1796874982198], order: [0, 1, 2] },
  'B050ORL0': { size: [FACTOR * 17.0898437491099, FACTOR * 30.7617187483978, FACTOR * 17.0898437491099], order: [0, 2, 1] },
  'B050ORL2': { size: [FACTOR * 30.7617187483978, FACTOR * 30.7617187483978], order: [0, 2] },
  'B050ORL3': { size: [FACTOR * 30.7617187483978, FACTOR * 30.7617187483978, FACTOR * 30.7617187483978], order: [0, 1, 2] },
  'B050SCR0': { size: [FACTOR * 20.5078124989319, FACTOR * 34.1796874982198, FACTOR * 20.5078124989319], order: [0, 2, 1] },
  'B050SCR2': { size: [FACTOR * 34.1796874982198, FACTOR * 34.1796874982198], order: [0, 2] },

  // Center pony classic font
  'C050CLA0': { size: [190, 190], order: [0, 2], minLength: 2 }

};

/* ----------  UV Map Sizes  ---------- */
const uvMap = {
  height: 300,
  width: 300
};

const nonMonogramUvMap = {
  height: 75,
  width: 700
};
/* =====  End of Define Families and Sizes.  ====== */

/* ==================================
=            allowed CA             =
================================== */

const allowedExtensions = [
  '_monogram',
  '_monogram_style',
  '_customization_selection',
  '_monogram_embroidery_color'
];
const parentAlias = [
  'left_chest',
  'center_chest',
  'right_hem',
  'hat_front',
  'hat_back'
];
const nonProductParentAlias = [
  'name_only',
  'name_and_date',
  'center',
  'corner'
];
const nonProductEdgeCaseAliases = [
  'name_and_date_monogram_line_1',
  'name_and_date_monogram_line_2'
];
const nonExistantEdgeCaseAliases = [
  'name_and_date_monogram'
];
const allowedAlias = allowedExtensions.reduce(function (accum, extension) {
  parentAlias.map(function (parent) {
    accum.push(parent + extension);
  });
  return accum;
}, []);

// First we reduce the list of allowed extensions and loop that over the list of nonProduct
// aliases. This gives us a general set of names.
// We also have some edge cases that need to be handled. To add specific aliases like multiline
// attributes you add them to `nonProductEdgeCaseAliases`. To remove specific aliases you add
// the alias to the `nonExistantEdgeCaseAliases`. These are usually the _monogram versions of
// _line_1 and _line_2 attributes.
const allowedNonProductAlias = allowedExtensions.reduce(function (accum, extension) {
  nonProductParentAlias.map(function (parent) {
    accum.push(parent + extension);
  });
  return accum;
}, [])
  .concat(nonProductEdgeCaseAliases)
  .filter((value) => nonExistantEdgeCaseAliases.indexOf(value) < 0);

/* =====  End of allowed CA  ====== */



module.exports = {
  fonts,
  sizes,
  bigSizes,
  fontid,
  sizeMonogram,
  sizeStandardMonogram,
  uvMap,
  nonMonogramUvMap,
  allowedAlias,
  parentAlias,
  allowedNonProductAlias,
  nonProductParentAlias
};
